import React from "react"
import { useSelector } from "react-redux"
import { Link, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"

import { getLoggedIn, getAccessToken } from "src/reducers/reducer_core"

/**
 * Floating support button, on every page.
 *
 * Deliberately just a link: it opens the full support page rather than a docked
 * panel, so there is one place a conversation happens and no second, smaller
 * copy of the thread UI to keep in step.
 *
 * Signed-out visitors get nothing — every support endpoint needs a session, so a
 * launcher would only lead to a 401.
 */
const SupportWidget = () => {
    const { t } = useTranslation()
    const { pathname } = useLocation()

    const loggedIn = useSelector(getLoggedIn)
    const accessToken = useSelector(getAccessToken)
    const isLoggedIn = !!(loggedIn || accessToken)

    // It would float on top of the very page it links to.
    if (!isLoggedIn || pathname.startsWith("/profile/support")) return null

    return (
        <div className="sup-widget">
            <Link to="/profile/support" className="sup-widget-btn" aria-label={t("support.title")} title={t("support.title")}>
                {/* Filled speech bubble with three dots — the conventional chat
                    mark, which reads at 24px where a thin outline does not. */}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M12 3C6.94 3 3 6.46 3 10.7c0 2.2 1.07 4.18 2.83 5.57-.12 1.2-.55 2.4-1.4 3.4-.2.24-.03.6.28.57 1.9-.2 3.42-.9 4.5-1.63.88.2 1.82.3 2.79.3 5.06 0 9-3.46 9-7.7S17.06 3 12 3z" />
                    <circle cx="8.2" cy="10.7" r="1.15" fill="#14122B" />
                    <circle cx="12" cy="10.7" r="1.15" fill="#14122B" />
                    <circle cx="15.8" cy="10.7" r="1.15" fill="#14122B" />
                </svg>
            </Link>
        </div>
    )
}

export default SupportWidget
